import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { PayloadStates } from '@lore/utils';
import Loader from '../../../components/Loader';
import useProjectTags from '../../../hooks/useProjectTags';
import TagTypes from '../../../constants/TagTypes';
import useTags from '../../../hooks/useTags';
import SubSectionHeader from '../../../components_profiles/SubSectionHeader';
import Tag from '../../../components/Tag';
import TextContentSection from '../../../components_profiles/TextContentSection';

Activities.propTypes = {
  project: PropTypes.object.isRequired
};

export default function Activities(props) {
  const { project } = props;

  const activities = useTags(TagTypes.Activity);
  const projectActivities = useProjectTags(project, TagTypes.Activity);

  if (projectActivities.state === PayloadStates.FETCHING) {
    return (
      <Loader />
    );
  }

  return (
    <TextContentSection title="Activities">
      <ul className="list-disc ml-6">
        {activities.data.map(function(activity) {
          const projectActivity = _.find(projectActivities.data, function(projectActivity) {
            return projectActivity._tag.id === activity.id;
          });

          if (!projectActivity) {
            return null;
          }

          return (
            <li key={activity.id || activity.cid}>
              {activity.data.name}
            </li>
          );
        })}
      </ul>
    </TextContentSection>
  );
};
